<template>
    <div class="index">
        <theHeader />
        <div class="main">
            <router-view></router-view>
        </div>
        <TheFotter class="position" />
    </div>
</template>

<script>
import TheHeader from "@/components/index/TheHeader";
import TheFotter from "@/components/index/TheFotter";
export default {
    components: {
        TheHeader,
        TheFotter
    },
    data() {
        return {};
    },
    created() {},
    mounted() {},
    methods: {}
};
</script>


<style scoped lang="scss">
.index {
    // position: relative;
    // .position {
    //     position: absolute;
    //     bottom: 0;
    // }
}
</style>
